module.exports = __webpack_public_path__ + "img/5_54.2fb04a93.png";